import { Stack, Typography } from '@mui/material';
import Iconify from 'src/components/iconify';
import {
  NavAccordionDetails,
  NavAccordionSummary,
} from 'src/features/Navbar/NavAccordion';
import { NavAccordionLabel } from 'src/features/Navbar/NavAccordion/NavAccordion';
import { NavAccordionPersisted } from 'src/features/Navbar/NavAccordionPersisted';
import { useUserRecents } from 'src/hooks/recents';
import { useLocales } from 'src/locales';
import { useNavbarContext } from 'src/provider/NavbarContext';
import { collaborateFeatures } from 'src/sections/@dashboard/recents/shared';
import { UIFeature } from 'src/state/ui/types';
import { ExpandCollapseIcon } from '../shared/ExpandCollapseIcon';
import { MoreNavItensButton } from '../shared/MoreNavItensButton';
import { NavRootList } from '../shared/styles';
import { NavRecentChatItem } from './NavRecentChatItem';
import { NavRecentItem } from './NavRecentItem';
import { useNavRecentsMoreDrawer } from './RecentsMoreDrawer';

export const NavRecents = () => {
  const { translate } = useLocales();
  const { recents, allRecents } = useUserRecents();
  const { hiddenNavBar } = useNavbarContext();
  const { showNavRecentsMoreDrawer } = useNavRecentsMoreDrawer();

  return (
    <NavAccordionPersisted
      feature={UIFeature.recents}
      sx={{ paddingTop: (theme) => theme.spacing(2) }}
    >
      <NavAccordionSummary className="recents">
        <NavAccordionLabel>
          <Iconify className="navIcon" icon="tabler:clock" />
          <Typography variant="subtitle2" whiteSpace="nowrap">
            {translate('header.nav.recents')}
          </Typography>
        </NavAccordionLabel>
        <ExpandCollapseIcon />
      </NavAccordionSummary>
      <NavAccordionDetails>
        {!recents?.length && (
          <Stack sx={{ textAlign: 'center', p: 2 }}>
            <Typography variant="caption" color="text.secondary">
              {translate('header.nav.recents.empty_state')}
            </Typography>
          </Stack>
        )}

        {recents && (
          <NavRootList disablePadding>
            {recents.map((recent) =>
              recent.priority || collaborateFeatures[recent.feature] ? (
                <NavRecentChatItem key={recent.url} recent={recent} />
              ) : (
                <NavRecentItem key={recent.url} recent={recent} />
              ),
            )}
            {allRecents?.length > 5 && (
              <MoreNavItensButton
                onClick={() => showNavRecentsMoreDrawer(hiddenNavBar)}
              />
            )}
          </NavRootList>
        )}
      </NavAccordionDetails>
    </NavAccordionPersisted>
  );
};
